import React, {useEffect} from 'react';
import {UserApi, UserDto} from '../../scaffold';
import {useInput} from 'react-hanger';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {Button, Form, Input, message, Select, Skeleton, Space} from 'antd';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import {SpecialtyCommitteeList} from '../../utils/CommitteeList';
import Flex from '../Flex';

export default function EditManagerForm(props: {onSuccess: (v: UserDto) => any; onCancel: () => void; id?: number}) {
  const committeeName = useInput('');
  const password = useInput('');

  const saveHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userSaveManagerPost);
  const findHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userFindGet);
  function onSubmit() {
    saveHook
      .request({
        saveManagerParams: {
          committeeName: committeeName.value.trim(),
          password: password.value.trim(),
        },
      })
      .then(res => {
        props.onSuccess(res);
        message.success('保存成功');
      })
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    if (props.id) {
      findHook
        .request({id: props.id})
        .then(res => {
          committeeName.setValue(res?.telephone || '');
          password.setValue('KeepUp');
        })
        .catch(CommonApiErrorHandler);
    }
  }, [props.id]);
  const committeeOptions = [{value: '', label: '请选择', disabled: true}, ...SpecialtyCommitteeList.map(i => ({value: i}))];

  return (
    <div>
      <Skeleton loading={findHook.loading}>
        <Form labelCol={{span: 7}}>
          <Form.Item label={'负责专委会'} required>
            <Select placeholder={'请选择'} {...committeeName.valueBind} options={committeeOptions} style={{width: '100%'}} />
          </Form.Item>
          {!props.id && (
            <Form.Item label={'密码'} required>
              <Input placeholder={'请输入密码'} {...password.eventBind} />
            </Form.Item>
          )}
        </Form>
        <Flex justify={'flex-end'} className={'p-b-20'}>
          <Space>
            <Button type={'primary'} onClick={onSubmit} loading={saveHook.loading}>
              保存
            </Button>
            <Button onClick={props.onCancel}>取消</Button>
          </Space>
        </Flex>
      </Skeleton>
    </div>
  );
}
